import script from "./BatchProfileTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchProfileTable.vue?vue&type=script&setup=true&lang=js"

import "./BatchProfileTable.vue?vue&type=style&index=0&id=26f0e9a3&lang=css"

const __exports__ = script;

export default __exports__